import React, { useState } from 'react'
import cn from 'classnames'

type Props = {
  summary: React.ReactNode
  details: React.ReactNode
  background: 'white' | 'beige-lightest'
}

function CollapsableBox({ summary, details, background = 'white' }: Props) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div
      className={cn(
        `bg-${background}`,
        'c-disclosure-summary',
        background === 'white' ? 'border-Border' : 'border-white',
        'border-t',
        'first:border-0',
        'first:rounded-t-16',
        'last:rounded-b-16',
      )}
    >
      <div
        className="c-faq__q-heading s-text flex cursor-pointer py-16 pr-24"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span
          className={cn(
            'text-green',
            'mt-2',
            'type-28',
            'font-regular',
            'border-2',
            'border-green',
            'rounded-full',
            'text-center',
            'mx-12',
            { 'border-purple text-purple': isOpen },
            'shrink-0',
          )}
          style={{
            height: '29px',
            width: '29px',
            lineHeight: '27px',
          }}
        >
          {isOpen ? '–' : '+'}
        </span>
        <span className="pt-2">{summary}</span>
      </div>
      {isOpen && (
        <div className="s-text px-24 text-left" style={{ marginLeft: '29px' }}>
          {details}
        </div>
      )}
    </div>
  )
}

export default CollapsableBox
